// Node only supports en-US by default, need to polyfill.
if (typeof window === "undefined") {
    // tslint:disable-next-line: no-var-requires
    const IntlPolyfill = require("intl");

    Intl.NumberFormat = IntlPolyfill.NumberFormat;
}

export default class CurrencyService {
    private currency: string;
    private numberFormat: Intl.NumberFormat;
    private numberFormatWithoutDecimals: Intl.NumberFormat;

    constructor(currencyLocale = "es-ES", currencyCode = "EUR", currency = "€") {
        this.numberFormat = new Intl.NumberFormat(currencyLocale, {
            style: "currency",
            currency: currencyCode,
        });
        this.numberFormatWithoutDecimals = new Intl.NumberFormat(currencyLocale, {
            style: "currency",
            currency: currencyCode,
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
        });
        this.currency = currency;
    }

    public Format(
        value: number | string,
        { showCurrency = true, showDecimals = true } = {},
    ): string {
        const amount = typeof value === "string" ? this.parseAmount(value) : value;

        if (isNaN(amount)) {
            return value as string;
        }

        const formatToUse = showDecimals ? this.numberFormat : this.numberFormatWithoutDecimals;

        const parsedAmount = formatToUse.format(amount);
        if (!showCurrency) {
            return parsedAmount.replace(this.currency, "").trim();
            /*
                Not supported in safari.
                Should polyfill, but locales should be lazy-loaded.
                See https://www.npmjs.com/package/intl#intljs-and-browserifywebpack

                const parts = this.numberFormat.formatToParts(amount);
                return parts
                    .filter(({type}) => type !== "currency")
                    .map((part) => part.value).join("");
            */
        }

        return parsedAmount;
    }

    private parseAmount(value: string): number {
        return parseFloat(value.replace(",", "."));
    }
}
